import { PublicClientApplication } from "@azure/msal-browser"
import { InteractionRequiredAuthError } from "@azure/msal-browser"

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: import.meta.env.VITE_CLIENT_ID,
    authority: import.meta.env.VITE_MSAL_INSTANCE_AUTHORITY,
    redirectUri: window.location.origin
  }
})

export async function login() {
  await msalInstance.loginRedirect({
    scopes: [import.meta.env.VITE_API_REDIRECT_SCOPE]
  })
}

export async function getAccessToken() {
  const account = msalInstance.getActiveAccount()

  if (!account) {
    return null
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: [import.meta.env.VITE_API_REDIRECT_SCOPE],
      account
    })

    return response.accessToken
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {

      await msalInstance.acquireTokenRedirect({
        scopes: [import.meta.env.VITE_API_REDIRECT_SCOPE]
      })
    }

    throw error
  }
}

export async function initializeMsal() {
  await msalInstance.initialize()

  const response = await msalInstance.handleRedirectPromise()

  if (response?.account) {

    msalInstance.setActiveAccount(response.account)

    // 🔥 CRITICAL FIX
    sessionStorage.removeItem("msal_redirect_in_progress")
  } else {
    // Also restore account if already logged in
    const accounts = msalInstance.getAllAccounts()
    if (accounts.length > 0) {
      msalInstance.setActiveAccount(accounts[0])
    }
  }
}